<div style="display: block;">
  <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
    [plugins]="lineChartPlugins" [legend]="lineChartLegend" [chartType]="lineChartType">
  </canvas>
</div>